import { InfinitePagination } from '@funtech-int/rival';
import classnames from 'classnames';
import { useSignal } from '@funtech-int/rival-react';
import React, { FC, ReactNode } from 'react';
import { InView } from 'react-intersection-observer';

import styles from './ScrollSentinel.module.css';

interface ScrollSentinelProps {
    className?: string;
    pagination: InfinitePagination;
    skeleton?: ReactNode;
    direction: 'start' | 'end';
    orientation?: 'horizontal' | 'vertical';
    threshold?: number;
}

export const ScrollSentinel: FC<ScrollSentinelProps> = ({
    className,
    pagination,
    skeleton,
    direction,
    orientation = 'vertical',
    threshold = 400,
}) => {
    const status = useSignal(pagination.status);

    const handleIntersection = (inView: boolean) => {
        if (status === 'idle' && inView) {
            pagination.fetch();
        }
    };

    let rootMargin: string;

    if (orientation === 'vertical') {
        rootMargin =
            direction === 'end' ? `0px 0px ${threshold}px 0px` : `${threshold}px 0px 0px 0px`;
    } else {
        rootMargin =
            direction === 'end' ? `0px ${threshold}px 0px 0px` : `0px 0px 0px ${threshold}px`;
    }

    return (
        <InView rootMargin={rootMargin} onChange={handleIntersection}>
            {({ ref }) =>
                skeleton ? (
                    <div ref={ref} className={className}>
                        {skeleton}
                    </div>
                ) : (
                    <div ref={ref} className={classnames(styles.trigger, className)} />
                )
            }
        </InView>
    );
};
